import { forwardRef } from 'react';
import { IconNames } from '@shipengine/giger-theme';
import { Typography } from '../Typography/Typography.js';
import { getCrumbStyles, getCurrentCrumbStyles, getIconStyles } from './CrumbStyles.js';
import { jsxs, jsx } from '@emotion/react/jsx-runtime';
import { Link } from '../Link/Link.js';
import { Icon } from '../Icon/Icon.js';
import { IconSize } from '../Icon/types/size.js';

const formatLongCrumb = crumb => crumb.length > 30 ? crumb.substr(0, 30 - 1) + '…' : crumb;
const Crumb = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
    isCurrent,
    name,
    href,
    position,
    onClick,
    ...rest
  } = _ref;
  return jsxs("li", {
    itemScope: true,
    ref: ref,
    itemProp: "itemListElement",
    "data-id": "breadcrumb-listItem",
    "aria-label": "breadcrumb-listItem",
    itemType: "https://schema.org/ListItem",
    css: getCrumbStyles,
    ...rest,
    children: [position && jsx("meta", {
      itemProp: "position",
      content: position.toString()
    }), jsx(Typography, {
      bold: true,
      variant: "heading5",
      css: isCurrent && getCurrentCrumbStyles,
      children: isCurrent ? jsx("span", {
        title: name,
        itemProp: "name",
        children: formatLongCrumb(name)
      }) : jsx(Link, {
        onClick: onClick,
        href: href,
        title: name,
        itemProp: "item",
        children: jsx("span", {
          itemProp: "name",
          children: formatLongCrumb(name)
        })
      })
    }), !isCurrent && jsx(Icon, {
      css: getIconStyles,
      size: IconSize.SIZE_REGULAR,
      name: IconNames.CHEVRON_RIGHT
    })]
  });
});
Crumb.displayName = 'Crumb';

export { Crumb };
//# sourceMappingURL=Crumb.js.map
